
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import CustomChipLink from "../CustomChipLink.vue";
import {TRANSFER_STATUS} from "../../utils/buildingsTransfers";

@Component({
  components: {
    CustomChipLink,
  },
})
export default class TransferBanner extends Vue {

    @Prop()
    public buildingId?: number;

    @Getter private envCompanyId: number | null;

    private loadingIds: string[] = [];
    private transfers: any[] = null;
    private TRANSFER_STATUS = TRANSFER_STATUS;

    private getTransferPath = (transfer: any) => {
        return transfer.status === TRANSFER_STATUS.CREATED
        ? "Buildings.transfer.requested"
        : "Buildings.transfer.failed";
    }

    private mounted() {
      this.getTransfers();
    }

  /**
   * Accept an incoming building transfer.
   *
   * @param {string} id - The transfer id.
   * @returns {Promise} A promise that resolves when the building transfer is done.
   */
  private acceptTransfer(id: string) {
    this.loadingIds.push(id);
    return this.$store.dispatch("buildingTransfers/acceptTransfer", {
      transferId: id,
    })
      .then(() => {
        this.$store.commit("alerts/displaySuccess", {
                msg: this.$i18n?.t("alerts.transfer.success"),
            });
        this.$emit("success");
      })
      .catch((error) => {
          this.$store.commit("alerts/displayHttpError", {error});
        })
      .finally(() => {
        this.getTransfers();
        this.loadingIds = this.loadingIds.filter((id) => id !== id);

    });
  }

  /**
   * Get company's waiting transfers from the store.
   *
   * @private
   * @returns {Promise} A promise that resolves to the transfers list.
   */
  private getTransfers() {
    return this.$store.dispatch("companies/getCompanyBuildingTransfers", {
      companyId: this.envCompanyId,
      buildingId: this.buildingId,
    }).then((res) => this.transfers = res);
  }

  private closeFailedTransfer(id: string) {
    return this.$store.dispatch("buildingTransfers/abort", {
      transferId: id,
    });
  }
}
